import { Navigate } from 'react-router-dom';
import { useUserAuth } from '../../contexts/UserAuthContext';
import type { ReactNode } from 'react';

interface UserProtectedRouteProps {
  children: ReactNode;
}

/**
 * Route guard for the creator console (end-user Supabase session).
 * While the session is loading, shows a spinner. When there is no session,
 * redirects to the end-user login page (/accedi).
 *
 * Distinct from ProtectedRoute, which guards the legacy Proloco JWT surface.
 */
export function UserProtectedRoute({ children }: UserProtectedRouteProps) {
  const { session, isLoading } = useUserAuth();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          minBlockSize: '100dvh',
          background: 'var(--color-bg)',
        }}
      >
        <div
          style={{
            width: '2rem',
            height: '2rem',
            border: '3px solid var(--color-border)',
            borderTopColor: 'var(--color-primary)',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/accedi" replace />;
  }

  return <>{children}</>;
}
